import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faArrowRight,
	faArrowUpRightFromSquare,
	faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { usePortfolioData } from "../contexts/DataContext";
import "./styles/ProjectsSection.css";

const fadeUp = {
	hidden: { opacity: 0, y: 20 },
	visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const stagger = {
	hidden: {},
	visible: { transition: { staggerChildren: 0.04 } },
};

const staggerChild = {
	hidden: { opacity: 0, y: 12 },
	visible: { opacity: 1, y: 0, transition: { duration: 0.35 } },
};

const ProjectsSection = () => {
	const { data: INFO } = usePortfolioData();
	return (
		<section className="proj">
			<div className="content-wrapper">
				<motion.div
					className="proj__header"
					variants={fadeUp}
					initial="hidden"
					whileInView="visible"
					viewport={{ once: true }}
				>
					<span className="proj__label">What I'm building</span>
					<h1 className="proj__title">Projects</h1>
				</motion.div>

				{INFO.projects
					.filter((p) => p.highlight)
					.map((project, idx) => (
						<motion.article
							key={idx}
							className="proj__item"
							variants={fadeUp}
							initial="hidden"
							whileInView="visible"
							viewport={{ once: true, amount: 0.1 }}
						>
							<div className="proj__item-top">
								<div className="proj__item-meta">
									<span className="proj__item-status">{project.linkText}</span>
									<div className="proj__item-tags">
										{project.tags.map((t) => (
											<span key={t}>{t}</span>
										))}
									</div>
								</div>
								<h2 className="proj__item-title">{project.title}</h2>
								<p className="proj__item-desc">{project.description}</p>
							</div>

							{project.stats && (
								<div className="proj__item-stats">
									{Object.entries(project.stats).map(([key, val]) => (
										<div key={key} className="proj__stat">
											<span className="proj__stat-val">{val}</span>
											<span className="proj__stat-key">{key}</span>
										</div>
									))}
								</div>
							)}

							{project.features && (
								<motion.div
									className="proj__item-features"
									variants={stagger}
									initial="hidden"
									whileInView="visible"
									viewport={{ once: true }}
								>
									{project.features.map((f, i) => (
										<motion.span key={i} className="proj__feat" variants={staggerChild}>
											<FontAwesomeIcon icon={faChevronRight} className="proj__feat-arrow" />
											{f}
										</motion.span>
									))}
								</motion.div>
							)}

							{project.link && (
								<a href={project.link} target="_blank" rel="noopener noreferrer" className="proj__item-link">
									View project <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
								</a>
							)}

							<div className="proj__item-divider" />
						</motion.article>
					))}
				<motion.div
					className="proj__collab"
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true }}
					transition={{ duration: 0.6 }}
				>
					<h3 className="proj__collab-title">Got an idea?</h3>
					<p className="proj__collab-text">
						If you have a project idea and want to build something together, I'm always down to talk. I like working with people who actually want to ship things.
					</p>
					<Link to="/contact" className="proj__collab-link">
						Let's talk <FontAwesomeIcon icon={faArrowRight} />
					</Link>
				</motion.div>
			</div>
		</section>
	);
};

export default ProjectsSection;
